import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import CalendarDialog from "@/components/serveSearch/calendar/CalendarDialog";
import CalendarTermDialog from "@/components/serveSearch/calendar/CalendarTermDialog";
export default {
  name: "Calendar",
  components: {
    Sift: Sift,
    CalendarDialog: CalendarDialog,
    CalendarTermDialog: CalendarTermDialog
  },
  props: ["url", "app-data", "collecting"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      hasRole: false,
      loading: false,
      siftData: [],
      schoolYear: "-",
      semester: 1,
      starttime: "-",
      endtime: "-",
      month: "-",
      explains: "",
      list: [],
      checkBox: [],
      items: null,
      monthList: []
    };
  },
  computed: {
    monthIndex: function monthIndex() {
      var index = 0;

      for (var i in this.monthList) {
        if (this.month == this.monthList[i].value) {
          index = i;
        }
      }

      return index * 1;
    },
    showMonth: function showMonth() {
      var str = "-月";

      var _iterator = _createForOfIteratorHelper(this.monthList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (this.month == item.value) {
            str = item.label;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return str;
    },
    workDay: function workDay() {
      var day = 0;

      var _iterator2 = _createForOfIteratorHelper(this.list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          for (var i in item.list) {
            if (item.list[i].month && item.list[i].jobDate && (item.list[i].isvacation != "1" && i < 5 || item.list[i].isvacation == "2" && i >= 5)) {
              day++;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return day;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchSiftData();
  },
  methods: {
    clickItem: function clickItem(val) {
      this.items = val;
    },
    editDate: function editDate(val) {
      // id,日期,事件,是否批量
      var idArr = [],
          dateArr = [],
          itemArr = [],
          isvacation = null,
          isEdit = false;

      if (val) {
        // 点击某天
        idArr.push(val.wid);
        dateArr.push(val.currentdateStr);
        itemArr = val.items ? val.items : [""];
        isvacation = val.isvacation;
        isEdit = true;
      } else {
        // 点击批量
        var _iterator3 = _createForOfIteratorHelper(this.checkBox),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            // 把check的字符串分割成id和date
            var arr = item.split(","); // 判断id是否为null，为null改为后台需要的*号

            var idStr = arr[0] == "null" ? "*" : arr[0];
            idArr.push(idStr);
            dateArr.push(arr[1]);
            itemArr = [""];
            isvacation = null;
            isEdit = false;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      this.$refs.calendarDialog.showView(idArr, dateArr, itemArr, isvacation, isEdit);
    },
    clickMonth: function clickMonth(index) {
      this.initPage({
        schoolYear: this.schoolYear + "," + this.semester,
        mouth: this.monthList[index].value
      });
    },
    initPage: function initPage(clickObj) {
      var _this = this;

      this.loading = true;
      var obj = {};

      if (clickObj) {
        obj = clickObj;
      } else {
        if (this.siftData.length) {
          obj = this.$refs.sift.getValue();
        }
      }

      this.$http.post("/calendar/list", this.$qs.stringify(obj)).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          // this.list = data.resData;
          _this.schoolYear = data.resData.schoolYear;
          _this.semester = data.resData.semester;
          _this.starttime = data.resData.starttime;
          _this.endtime = data.resData.endtime;
          _this.month = data.resData.month;
          _this.monthList = data.resData.months;
          _this.explains = data.resData.explains;
          _this.list = data.resData.data;
          _this.checkBox = [];
          _this.items = null; // 如果默认当前月份没设置校历的时候，处理默认月份

          if (!_this.monthList) {
            var arr = [];
            var myData = new Date();
            var month = myData.getMonth() < 10 ? "0" + (myData.getMonth() + 1) : myData.getMonth() + 1;
            _this.month = myData.getFullYear() + "-" + month;
            _this.schoolYear = myData.getFullYear();
            arr.push({
              label: month + "月",
              value: _this.month
            });
            _this.monthList = arr;

            _this.$message.warning("当前 " + _this.month + " 还未设置校历，请优先设置！");
          }
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchSiftData: function fetchSiftData() {
      var _this2 = this;

      this.loading = true;
      this.$http.post("/calendar/condition").then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          _this2.siftData = data.resData.list;
          _this2.hasRole = data.resData.hasRole;

          _this2.$nextTick(function () {
            _this2.initPage(null);
          });
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 刷新条件列表
    getSiftData: function getSiftData() {
      var _this3 = this;

      this.loading = true;
      this.siftData = [];
      this.$http.post("/calendar/condition").then(function (_ref3) {
        var data = _ref3.data;

        if (data.resCode == 0) {
          _this3.siftData = data.resData.list;
          _this3.hasRole = data.resData.hasRole;
        }

        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 是否教学周
    isWeek: function isWeek(str) {
      if (typeof str == "string" && str.indexOf("not") > -1) {
        return "-";
      } else {
        return "第" + str + "周";
      }
    },
    itemClass: function itemClass(val, key) {
      var str = " "; // 字体颜色

      if (!val.month) {
        str += "grey ";
      } else {
        if (!val.jobDate) {
          str += "grey ";
        } else {
          if (key == 5 || key == 6) {
            str += "red ";
          }
        }
      } // 背景色


      if (!val.jobDate) {
        str += "bg-g ";
      }

      if (val.isvacation == "1") {
        str += "bg-red ";
      } else if (val.isvacation == "2") {
        str += "bg-g ";
      }

      return str;
    },
    showTerm: function showTerm() {
      this.$refs.calendarTermDialog.showView();
    }
  }
};